// import React, { useMemo } from "react";
// import useCommonStore from "../../../store/CommonStore";
// import { filterDataByDate } from "../../../common/Constants";

// interface CountryData {
//   name: string;
//   sessions: number;
//   flag: string;
// }

// interface TopCountriesProps {
//   data: any;
// }

// const countryFlags: { [key: string]: string } = {
//   India: "/charts/india.svg",
//   "United States": "/charts/us.svg",
//   Germany: "/charts/germany.svg",
//   Canada: "/charts/canada.svg",
//   France: "/charts/france.svg",
// };

// const TopCountriesChart: React.FC<TopCountriesProps> = ({ data }) => {
//   const { selectedValue } = useCommonStore();

//   const filteredData = useMemo(
//     () => filterDataByDate(data, selectedValue),
//     [data, selectedValue]
//   );

//   const countrySessions: { [key: string]: number } = {};

//   filteredData?.forEach((session: any) => {
//     const countryName = session.country?.[1];
//     if (countryName) {
//       countrySessions[countryName] = (countrySessions[countryName] || 0) + 1;
//     }
//   });

//   const sortedCountries: CountryData[] = Object.entries(countrySessions)
//     .map(([name, sessions]) => ({
//       name,
//       sessions,
//       flag: countryFlags[name] || "/charts/default.svg",
//     }))
//     .sort((a, b) => b.sessions - a.sessions);

//   const maxSessions = sortedCountries.length
//     ? Math.max(...sortedCountries.map((c) => c.sessions))
//     : 1;

//   return (
//     <div className="w-full h-full bg-white p-4 rounded-lg border relative hover:outline hover:outline-2 hover:outline-[#3F81FE]">
//       <h2 className="text-lg font-semibold mb-4 text-[#323232]">
//         Top Countries
//       </h2>
//       {sortedCountries.map((country, index) => (
//         <div key={index} className="w-full flex flex-col items-center mb-3">
//           {/* Country Name and Flag */}
//           <div className="w-full flex items-center gap-4">
//             <img src={country.flag} alt={country.name} className="w-4 h-3" />
//             <span className="text-[#323232]">{country.name}</span>
//           </div>

//           <div className="w-full flex gap-2 items-center">
//             {/* Bar */}
//             <div className="w-full flex-1 h-2 bg-white rounded-full relative">
//               <div
//                 className="h-2 bg-[#3F81FE] rounded-full"
//                 style={{
//                   width: `${(country.sessions / maxSessions) * 100}%`,
//                 }}
//               ></div>
//             </div>

//             {/* Sessions Count */}
//             <span className="ml-3 text-[#7e7e7e] text-sm">
//               {country.sessions} Sessions
//             </span>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default TopCountriesChart;

interface CountryData {
  name: string;
  sessions: number;
  flag: string;
}

interface TopCountriesProps {
  data: any;
}

const countryFlags: { [key: string]: string } = {
  India: "/charts/india.svg",
  "United States": "/charts/us.svg",
  Germany: "/charts/germany.svg",
  Canada: "/charts/canada.svg",
  France: "/charts/france.svg",
};

const TopCountriesChart: React.FC<TopCountriesProps> = ({ data }) => {
  // const { selectedValue } = useCommonStore();

  // const {filteredData} = useMemo(
  //   () => filterDataByDate(data, selectedValue),
  //   [data, selectedValue]
  // );

  const countrySessions: { [key: string]: number } = {};

  data?.Sessions?.forEach((session: any) => {
    if (Array.isArray(session.country) && session.country.length > 1) {
      const countryFull = session.country[1];
      const countryName = countryFull?.split(",")[0].trim();

      if (countryName) {
        countrySessions[countryName] = (countrySessions[countryName] || 0) + 1;
      }
    }
  });

  const sortedCountries: CountryData[] = Object.entries(countrySessions)
    .map(([name, sessions]) => ({
      name,
      sessions,
      flag: countryFlags[name] || "/charts/default.svg",
    }))
    .sort((a, b) => b.sessions - a.sessions);

  const maxSessions = sortedCountries.length
    ? Math.max(...sortedCountries.map((c) => c.sessions))
    : 1;

  return (
    <div className="w-full h-full bg-white p-4 rounded-lg border relative hover:outline hover:outline-2 hover:outline-[#3F81FE]">
      <h2 className="text-lg font-semibold mb-4 text-[#323232]">
        Top Countries
      </h2>
      {sortedCountries.map((country, index) => (
        <div key={index} className="w-full flex flex-col items-center mb-3">
          <div className="w-full flex items-center gap-4">
            <img src={country.flag} alt={country.name} className="w-4 h-3" />
            <span className="text-[#323232]">{country.name}</span>
          </div>

          <div className="w-full flex gap-2 items-center">
            <div className="w-full flex-1 h-2 bg-white rounded-full relative">
              <div
                className="h-2 bg-[#3F81FE] rounded-full"
                style={{
                  width: `${(country.sessions / maxSessions) * 100}%`,
                }}
              ></div>
            </div>

            <span className="ml-3 text-[#7e7e7e] text-sm">
              {country.sessions} Sessions
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TopCountriesChart;
